import { commonsApiClient } from "./client";
import {
  OnRegistrationSurveyRequest,
  OnRegistrationSurveyResponse,
  SurveyValidationError,
} from "../types/survey";

/**
 * Validates survey data following MVP validation patterns
 */
const validateSurveyData = (data: OnRegistrationSurveyRequest): void => {
  if (
    (!data.reason_for_signup || data.reason_for_signup.length === 0) &&
    !data.reason_for_signup_freeform
  ) {
    throw new SurveyValidationError(
      "Please specify your reason for signing up"
    );
  }

  if (
    data.reason_for_signup.includes("other") &&
    !data.other_signup_reason_text
  ) {
    throw new SurveyValidationError(
      "Please specify your reason for signing up"
    );
  }

  if (!data.user_self_identified_as) {
    throw new SurveyValidationError("Please specify how you self-identify");
  }

  if (
    data.user_self_identified_as === "other" &&
    !data.other_user_self_identified_as_text
  ) {
    throw new SurveyValidationError("Please specify how you self-identify");
  }
};

/**
 * Submits the on registration survey response
 */
export const submitOnRegistrationSurvey = async (
  userId: string,
  surveyData: OnRegistrationSurveyRequest
): Promise<OnRegistrationSurveyResponse> => {
  try {
    // Validate survey data
    validateSurveyData(surveyData);

    // Submit survey data
    const response = await commonsApiClient.post<OnRegistrationSurveyResponse>(
      `/api/survey-response/on-registration/${userId}`,
      surveyData
    );

    return response;
  } catch (error) {
    console.error("Survey submission error:", error);
    throw error;
  }
};
